// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationErrorUfoPath = 'M50 41.042a129.017 129.017 0 01-17.6-1.2 10.7 10.7 0 01-7.5-5 10.096 10.096 0 01-1.312-3.298C11.61 34.514 7 38.74 7 41c0 5.1 16.8 12.4 43 12.4S93 46.1 93 41c0-2.26-4.61-6.485-16.588-9.456a10.096 10.096 0 01-1.312 3.298 10.7 10.7 0 01-7.6 5 119.01 119.01 0 01-16.9 1.2H50zm25.283-16.86a27.501 27.501 0 00-50.566 0C8.94 27.482 0 33.547 0 41c0 9.734 14.574 15.883 32.462 18.27L15 81.9l3.4 2A62.2 62.2 0 0050 92.5a62 62 0 0032-8.9l3.4-2.1-17.227-22.317C85.77 56.736 100 50.619 100 41c0-7.453-8.94-13.517-24.717-16.818zM59.991 60.04c-3.296.239-6.647.359-9.991.359-3.125 0-6.256-.105-9.343-.314L25.5 79.8a55.3 55.3 0 0049.5-.3L59.991 60.041zM50 14.541a20.6 20.6 0 00-19.4 13.8 3.3 3.3 0 00.3 2.9 3.1 3.1 0 002.5 1.6 123.21 123.21 0 0017.2 1.2 107.72 107.72 0 0016-1.2 3.2 3.2 0 002.5-1.7 3.1 3.1 0 00.3-2.8 20.6 20.6 0 00-19.4-13.8zM20 46a4 4 0 100-8 4 4 0 000 8zm34 1.5a4 4 0 11-8 0 4 4 0 018 0zm28.5-5a4 4 0 11-8 0 4 4 0 018 0z';
var IllustrationErrorUfo = baseIllustration('IllustrationErrorUfo', {
  getPath: () => IllustrationErrorUfoPath
}, 'ColoredIllustrationErrorUFO');
IllustrationErrorUfo.displayName = 'IllustrationErrorUFO';

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationErrorUfo;
//# sourceMappingURL=index.js.map